import {DesignField} from '../../../stores/DesignField';
import {SubscreenCollection} from './SubscreenCollection';
import {override} from 'mobx';
import {maxFieldsToShow} from '../consts/consts';

export class SubscreenField extends DesignField {
    constructor(field, parentField) {
        super(field, parentField);
        this.collection = new SubscreenCollection(parentField.collection);
    }

    setCollection(field) {
        this.collection = new SubscreenCollection(field.collection);
        field.fields && this.collection.insertFields(this, field.fields);
    }

    @override
    get isActive() {
        return (
            this.screen.active &&
            this.screen.active.name === this.name &&
            this.screen.parentScreen.active &&
            this.screen.parentScreen.active.name === this.name
        );
    }

    @override
    get isHiddenStatusUnchangable() {
        return this.parentCollection.firstHiddenIdx === maxFieldsToShow && this.hidden;
    }
}
